exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-search-cam-list[data-v-2c2399b2] {\n  padding: 1rem;\n}\n.account-selected[data-v-2c2399b2] {\n  margin-left: 6rem;\n}\n.route-title[data-v-2c2399b2] {\n  margin-right: 1rem;\n}\n.move-width[data-v-2c2399b2] {\n  width: 70% !important;\n}\n.scrollable-table[data-v-2c2399b2] {\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n}\n", ""]);

// exports
